import TrimbleMaps from "@trimblemaps/trimblemaps-js"
import MapConstant from "./mapconstants"
import {STYLES} from "../styles/theme"

export default class MapHelper {
  static config ={
    accessKey: "",
    theme:{},
    country: "",
    geoCodeUrl: ""
  }

  static styles = {
    light:"",
    dark:""
  }

  static updateStyleKey = (style, mapConfig) => {
    const styleString = JSON.stringify(style);
    let updatedStyle = styleString.replaceAll(
      "key=customKey",
      `key=${mapConfig.accessKey}`
    );
    updatedStyle = updatedStyle.replaceAll(
      "authToken=customKey",
      `authToken=${mapConfig.accessKey}`
    );
    updatedStyle = JSON.parse(updatedStyle);
    if (!mapConfig.enableTrafficWeatherLayer) {
      const {WeatherAlerts, WeatherCloud, Traffic, ...others} = updatedStyle.sources
      updatedStyle = {
        ...updatedStyle,
        sources: others,
        layers: updatedStyle.layers.filter(
          (layer) =>
            !(layer.id?.includes("weather") || layer.id?.includes("traffic"))
        ),
      };
    }
    return updatedStyle;
  };

  static setConfig = (config) => {
    MapHelper.config = config;
      MapHelper.config.theme={
        "dark": "datadark",
        "light": "datalight",
        "satellite": "satellite"
      }
    MapHelper.styles.datalight = MapHelper?.styles?.datalight || MapHelper.updateStyleKey(STYLES.datalight, MapHelper.config)
    MapHelper.styles.datadark = MapHelper?.styles?.datadark || MapHelper.updateStyleKey(STYLES.datadark, MapHelper.config)
  }

  static getMapStyle = (themeName) => {
    const styleName = MapHelper.config.theme[themeName];
   return  MapHelper.styles[styleName] || styleName || MapHelper.config.light;
  };

  static getKey = () => {
    return MapHelper.config.accessKey;
  };

  static getGeoCodingAPIEndPoint = () => {
    return MapHelper.config.geoCodeUrl;
  };

  static getCountry = () => {
    return MapHelper.config.country;
  };

  static getDistance =  (points) => {
    const stopPoints  = points.map(point => point.join(",")).join(";");
    return fetch(`https://pcmiler.alk.com/apis/rest/v1.0/Service.svc/route/routeReports?stops=${stopPoints}&reports=Mileage&vehType=${TrimbleMaps.Common.VehicleType.TRUCK}&vehDimUnits=${TrimbleMaps.Common.TruckUnit.METRIC}&vehHeight=${MapConstant.truckProfile.costing_options.height}&vehLength=${MapConstant.truckProfile.costing_options.length}&vehWidth=${MapConstant.truckProfile.costing_options.width}&vehWeight=${MapConstant.truckProfile.costing_options.weight}&hazMat=${TrimbleMaps.Common.HazMatType.GENERAL}`,
        {headers:{authorization:MapHelper.getKey()}})
        .then(response => response.json())
        .then(data => {
          const { TMiles, THours} = data[0].ReportLines[data[0].ReportLines.length-1];
          if(TMiles && THours){
            const [hour, mins] = THours.split(":");
            return { distance: TMiles, duration: Number(hour) * 60 + Number(mins)}
          }
          return null   
        }).catch(error =>  null)
  };
}